/*Mahesh S  : 05-10-2023 : BT-105135 -  Breeze- Portfolio Holdings - Start*/
import { memo, useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import AnalyticsTabs from './AnalyticsTabs';
import Summary from './Summary';
import HoldingsGrid from './HoldingsGrid/index';
import { updateDefaultManageColumnName, updateStrViewType } from '../../redux/actions/watchlist';
import { DEFAULT_MANAGE_COLUMN_PROFILE_NAME, MANAGE_COLUMNS_VIEW_TYPES } from '../../utils/global_variables';
import { handleModal } from '../../redux/actions/modals';
import { useKeyWithShift } from '../../hooks';
import { useDispatch } from 'react-redux';
import config from '../../config.json';


const HoldingsContent = ({ objPortfolioSumaary, handleCreateWatchlist, handleExpandHoldings, toggleTabs,
    nActiveCardIndex, nASetActiveCardIndex, objEvent, gridDetailCellRenderer, arrRecommendationsInfo,
    areaChartConfig, arrHoldingsColumnDefs, arrGridRowData, isSuppressMenu, heatmapChartConfig,
    isShowHoldingsFilterModelsModal, setIsShowHoldingsFilterModelsModal, handleDelete, temp, tempFilter,
    heatMapToggle, setHeatMapToggle, activeButtonToggleIndex, setActiveButtonToggleIndex, gridRef, expand,
    setExpand, setPriceValueView, priceValueView, isGlobalSearch = false }) => {

    const dispatch = useDispatch();
    const [activeTabkey, setActiveTabkey] = useState('analysis'); //ManasaB : 05-07-2024 : Hotfix changes
    const [activePage, setActivePage] = useState(null); //Ameersha N--Changed to null as null condition need check to add listner only this content is active onClick ,as foucs is on Holdings Grid


    useKeyWithShift('v', (e) => {
        if (config.bIsProd !== 'true') {
            dispatch(updateDefaultManageColumnName(DEFAULT_MANAGE_COLUMN_PROFILE_NAME.HOLDINGS));
            dispatch(updateStrViewType(MANAGE_COLUMNS_VIEW_TYPES?.HOLDINGS_VIEW_TYPE));
            dispatch(handleModal([{ "WATCHLIST_MANAGE_COLUMNS_MODAL": true }]));
        } else { }

    });
    const handleChangePage = (e) => {
        let key = e?.key;
        let ctrlKey = e?.ctrlKey;
        if (ctrlKey) {
            if (key === 'ArrowLeft') {
                setActivePage(true);
            }
            if (key === 'ArrowRight') {
                setActivePage(false);
            }
        }
    };
    useEffect(() => {
        document.addEventListener('keydown', handleChangePage);
        return () => {
            document.removeEventListener('keydown', handleChangePage);
        };
    }, [handleChangePage]);


    return (
        <>
            {!expand ?
                <Row className='g-0'>
                    <Col md={!toggleTabs ? 5 : 12} className='expand-collapse-block mt-3' data-testid="portfolio-holdings-grid-container" onClick={() => { setActivePage(true); }}>
                        <HoldingsGrid handleExpandHoldings={handleExpandHoldings} isGlobalSearch={isGlobalSearch}
                            handleCreateWatchlist={handleCreateWatchlist} toggleTabs={toggleTabs}
                            arrHoldingsColumnDefs={arrHoldingsColumnDefs} isMasterDetail
                            arrGridRowData={arrGridRowData} isSuppressMenu={isSuppressMenu} activePage={activePage}
                            gridDetailCellRenderer={gridDetailCellRenderer}
                            isShowHoldingsFilterModelsModal={isShowHoldingsFilterModelsModal}
                            setIsShowHoldingsFilterModelsModal={setIsShowHoldingsFilterModelsModal}
                            handleDelete={handleDelete} temp={temp} tempFilter={tempFilter}
                            heatmapChartConfig={heatmapChartConfig} heatMapToggle={heatMapToggle}
                            setHeatMapToggle={setHeatMapToggle} activeButtonToggleIndex={activeButtonToggleIndex}
                            setActiveButtonToggleIndex={setActiveButtonToggleIndex} gridRef={gridRef}
                            setPriceValueView={setPriceValueView} priceValueView={priceValueView}
                        />
                    </Col>
                    {!toggleTabs &&
                        <Col md={7} className='bdr-lft' data-testid="portfolio-analytics-section" onClick={() => { setActivePage(false); }} >
                            <Summary className='bdr-btm pb-3' objPortfolioSumaary={objPortfolioSumaary} />
                            <AnalyticsTabs
                                arrGridRowData={arrGridRowData} activePage={activePage} isGlobalSearch={isGlobalSearch}
                                objPortfolioSumaary={objPortfolioSumaary}
                                nActiveCardIndex={nActiveCardIndex} nASetActiveCardIndex={nASetActiveCardIndex}
                                arrRecommendationsInfo={arrRecommendationsInfo} objEvent={objEvent} areaChartConfig={areaChartConfig}
                                expand={expand} setExpand={setExpand} activeTabkey={activeTabkey} setActiveTabkey={setActiveTabkey}
                            />
                        </Col>
                    }
                </Row>
                :
                <Col md={12} className='bdr-rgt'>
                    <AnalyticsTabs
                        objPortfolioSumaary={objPortfolioSumaary} activePage={activePage} isGlobalSearch={isGlobalSearch}
                        nActiveCardIndex={nActiveCardIndex} nASetActiveCardIndex={nASetActiveCardIndex}
                        arrRecommendationsInfo={arrRecommendationsInfo} objEvent={objEvent} areaChartConfig={areaChartConfig}
                        expand={expand} setExpand={setExpand} activeTabkey={activeTabkey} setActiveTabkey={setActiveTabkey}
                    />
                </Col>
            }
        </>
    );
};

export default memo(HoldingsContent);
/*Mahesh S  : 05-10-2023 : BT-105135 -  Breeze- Portfolio Holdings -end*/